import { type FC, useEffect } from "react";
import { Dialog, type DialogProps } from "@cmsgov/ds-medicare-gov";

export const MandatoryDialog: FC<DialogProps> = ({
  children,
  ...otherProps
}) => {
  useEffect(() => {
    const handleEscapeButton = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
      }
    };
    document.addEventListener("keydown", handleEscapeButton, { capture: true });
    return () => document.removeEventListener("keydown", handleEscapeButton);
  }, []);

  return <Dialog {...otherProps}>{children}</Dialog>;
};
